import React, { useState, useEffect } from "react";
import _ from "lodash";
import { AXIOS } from "../api";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { ChromePicker } from "react-color";
import { useForm } from "react-hook-form";
import DatePicker from "react-date-picker";
import moment from "moment";
import Switch from "react-switch";
import { TwitterPicker } from "react-color";

import { setLoading, setFetch } from "../redux/actions";

import { ACTIVITES_ID } from "../database";
import ItemsList from "./common/ItemsList";
import { Icons, Title, Picture, Heading, PictureItem } from "./common/Themes";

const UpdateFormule = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [, type, fid] = location.pathname.split("/");

  const { activites, offres, formules, accessoires, articles, taches, rooms } =
    useSelector((state) => state.fetch);
  const { fetch } = useSelector((state) => state.config);

  const [formule, setFormule] = useState({});
  const [articlesFill, setArticlesFill] = useState([]);
  const [subformules, setSubformules] = useState([]);

  const [relatedPack, setRelatedPack] = useState("");
  const [relatedPackInputValue, setRelatedPackInputValue] = useState("");
  const [relatedPlannings, setRelatedPlannings] = useState("");
  const [relatedPlanningsInputValue, setRelatedPlanningsInputValue] =
    useState("");

  const [relatedAccessoires, setRelatedAccessoires] = useState("");
  const [relatedAccessoiresInputValue, setRelatedAccessoiresInputValue] =
    useState("");
  const [relatedRooms, setRelatedRooms] = useState("");
  const [relatedRoomsInputValue, setRelatedRoomsInputValue] = useState("");
  const [value, onChange] = useState(new Date());
  const [activeDate, setActiveDate] = useState(false);

  const [name, setName] = useState("");
  const [strings, setStrings] = useState(["", ""]);
  const [aaid, setAaid] = useState("");
  const [file, setFile] = useState();
  const [fileBorne, setFileBorne] = useState();
  const [fileAds, setFileAds] = useState();
  const [imageURL, setImageURL] = useState("");
  const [color, setColor] = useState({
    hex: "#FF5C00",
    rgb: { r: 245, g: 68, b: 46, a: 0.8 },
  });
  const [selectedArticle, setSelectedArticle] = useState(null);

  const [idArticles, setIdArticles] = useState([]);
  const [idRooms, setIdRooms] = useState([]);
  const [cidAccessoires, setCidAccessoires] = useState([]);

  const [web, setWeb] = useState(true);
  const [borne, setBorne] = useState(true);
  const [promotion, setPromotion] = useState(true);

  const [primaryColor, setPrimaryColor] = useState("#000");
  const [secondaryColor, setSecondaryColor] = useState("#000");
  const [backgroundColor, setBackgroundColor] = useState("#000");

  const [idTaches, setIdTaches] = useState([]);

  useEffect(() => {
    setIdTaches(taches.map(({ id }) => id));
    setCidAccessoires(accessoires.map(({ cid }) => cid));
  }, [articles, taches, accessoires]);

  useEffect(() => {
    (async () => {
      const formule = formules.filter((item) => item.fid === fid)[0];

      if (formule?.fid) {
        setFormule(formule);
        setName(formule?.name);
        setColor({ hex: formule?.color });
        setImageURL(`${process.env.REACT_APP_SITE_MARCHAND}${formule?.image}`);
        setImageBorne(
          `${process.env.REACT_APP_SITE_MARCHAND}${formule?.image_borne}`
        );
        setImageAds(
          `${process.env.REACT_APP_SITE_MARCHAND}${formule?.image_ads}`
        );
        setSelectedArticle(formule?.article);
        setRelatedRooms(formule?.rooms);

        setWeb(formule?.web);
        setBorne(formule?.borne);
        setPromotion(formule?.promotion);

        setRelatedPack(formule?.relatedPack);
        setRelatedAccessoires(formule?.relatedAccessoires);

        setRelatedPlannings(formule?.plannings);
        // setRelatedAccessoires(formule?.equipements);

        setPrimaryColor(formule?.colors?.primary);
        setSecondaryColor(formule?.colors?.secondary);
        setBackgroundColor(formule?.colors?.background);
      }

      if (!!formule?.strings) {
        try {
          const STRINGS = formule?.strings
            ?.replace(/\\n/g, "\n")
            .replace(/\\/g, "");
          setStrings(JSON.parse(STRINGS.trim()));
        } catch (error) {
          console.error("Failed to parse JSON:", error.message);
        }
      }

      if (!formule?.date) {
        setActiveDate(false);
        onChange(new Date());
      } else {
        setActiveDate(true);
        onChange(new Date(formule?.date));
        // onChange(moment(formule?.date, 'YYYY-MM-D').format('D/MM/YYYY'));
      }

      if (!aaid) {
        setAaid(formule?.aid);
      }

      // GET ALL THE ACTIVITES FROM DATABASE
      const response = await AXIOS.get("/api/v1/subFormules");
      setSubformules(
        response.data.data.subFormules.filter(
          ({ anniv_formule }) => anniv_formule === fid
        )
      );
    })();
  }, [fid, aaid, formules]);

  useEffect(() => {
    setArticlesFill(articles);
    setIdArticles(articles.map(({ id }) => id));
    setIdRooms(rooms.map(({ id }) => id.toString()));
    setCidAccessoires(accessoires.map(({ cid }) => cid));
  }, [articles, rooms, accessoires]);

  // const onSubmit = async (values) => {
  //     console.log(relatedPack, relatedAccessoires)
  // }

  const onSubmit = async (values) => {
    try {
      dispatch(setLoading(false));
      const {
        aid,
        oid,
        name,
        classement,
        linked_formule1,
        start1,
        linked_formule2,
        start2,
        placesMin,
        placesMax,
      } = values;

      const body = {
        aid,
        oid,
        name,
        classement,
        placesMin,
        placesMax,
        rooms: relatedRooms,
        color: color.hex,
        strings: JSON.stringify({
          string_1: values?.topText?.replace(/\n/g, "<br/>"),
          string_2: values?.bottomText?.replace(/\n/g, "<br/>"),
        }),
        article: selectedArticle,
        web,
        borne,
        promotion,
        relatedPack,
        relatedAccessoires,
        plannings: relatedPlannings,
        equipements: relatedAccessoires,
        colors: {
          primary: primaryColor,
          secondary: secondaryColor,
          background: backgroundColor,
        },
        image: `/uploads/formules/${fid}.png?cache=${new Date().getTime()}`,
        image_borne: `/uploads/formules/borne-${fid}.png?cache=${new Date().getTime()}`,
        image_ads: `/uploads/formules/ads-${fid}.png?cache=${new Date().getTime()}`,
      };

      if (aid === ACTIVITES_ID[`evenements`])
        if (activeDate) body.date = value;
        else body.date = null;

      let subFormuleBody = [];

      subFormuleBody[0] = {
        linked_formule: linked_formule1,
        start: start1 * 1,
      };

      subFormuleBody[1] = {
        linked_formule: linked_formule2,
        start: start2 * 1,
      };

      // 👽 UPDATE IMAGE REQUEST
      if (!_.isEmpty(file)) {
        const formData = new FormData();
        formData.append("file", file);
        await AXIOS.post(`/api/v1/uploads/formules/${fid}`, formData);
      }

      // 👽 UPDATE IMAGE REQUEST
      if (!!fileBorne?.name && true) {
        console.log(fileBorne);
        const formData = new FormData();
        formData.append("file", fileBorne);
        await AXIOS.post(`/api/v1/uploads/formules/borne-${fid}`, formData);
      }

      // 👽 UPDATE IMAGE REQUEST
      if (!!fileAds?.name && true) {
        console.log("inside : ", fileAds);
        const formData = new FormData();
        formData.append("file", fileAds);
        await AXIOS.post(`/api/v1/uploads/formules/ads-${fid}`, formData);
      }

      // 👽 UPDATE FORMULE REQUEST
      await AXIOS.patch(`/api/v1/formules/${fid}`, body);

      // 👽 ADD SUBFORMULE REQUEST
      subFormuleBody.map(async (body, index) => {
        if (subformules[index]?.sid)
          await AXIOS.patch(
            `/api/v1/subFormules/${subformules[index]?.sid}`,
            body
          );
        else
          await AXIOS.post("/api/v1/subFormules", {
            anniv_formule: fid,
            ...body,
          });
      });

      history.push("/formules");
      dispatch(setFetch(!fetch));
      dispatch(setLoading(false));
    } catch (error) {
      console.log(error);
    }
  };

  const { handleSubmit, register, errors, watch } = useForm();

  // DROPZONE IMAGE --------------------------------------------------------------------------------------------------------
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) => {
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        });
        setFile(acceptedFiles[0]);
        const reader = new FileReader();
        reader.onload = (event) => {
          setImageURL(event.target.result);
        };
        reader.readAsDataURL(file);
      });
    },
  });

  const [imageBorne, setImageBorne] = useState(
    `${process.env.REACT_APP_SITE_MARCHAND}/img/default_image_borne.png`
  );
  const fileInputRef = React.useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      setFileBorne(file);
      reader.onloadend = () => {
        setImageBorne(reader.result); // Set the base64 image as state
      };
      reader.readAsDataURL(file); // Read the file as data URL
    }
  };

  const [imageAds, setImageAds] = useState("/img/default_image.png");
  const fileInputAdsRef = React.useRef(null);

  const handleImageAdsChange = (e) => {
    const file = e.target.files[0];

    console.log(file);
    if (file) {
      const reader = new FileReader();
      setFileAds(file);
      reader.onloadend = () => {
        setImageAds(reader.result); // Set the base64 image as state
      };
      reader.readAsDataURL(file); // Read the file as data URL
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click(); // Trigger the hidden file input
  };
  const handleUploadAdsClick = () => {
    fileInputAdsRef.current.click(); // Trigger the hidden file input
  };

  const handleChangeRelatedPack = (e) => {
    if (idArticles.includes(e.target.value * 1)) {
      if (relatedPack.length > 0)
        setRelatedPack(`${relatedPack},${e.target.value}`);
      else setRelatedPack(e.target.value);
    }
    setRelatedPackInputValue(e.target.value);
  };
  const deleteRelatedPack = (id) => {
    if (relatedPack?.includes(`${id},`))
      setRelatedPack(relatedPack.replace(`${id},`, ""));
    else if (relatedPack?.includes(`,${id}`))
      setRelatedPack(relatedPack.replace(`,${id}`, ""));
    else setRelatedPack(relatedPack?.replace(`${id}`, ""));
  };

  const handleChangeRelatedPlannings = (e) => {
    if (idTaches.includes(e.target.value * 1)) {
      if (relatedPlannings?.length > 0)
        setRelatedPlannings(`${relatedPlannings},${e.target.value}`);
      else setRelatedPlannings(e.target.value);
    }
    setRelatedPlanningsInputValue(e.target.value);
  };
  const deleteRelatedPlannings = (id) => {
    if (relatedPlannings?.includes(`${id},`))
      setRelatedPlannings(relatedPlannings.replace(`${id},`, ""));
    else if (relatedPlannings?.includes(`,${id}`))
      setRelatedPlannings(relatedPlannings.replace(`,${id}`, ""));
    else setRelatedPlannings(relatedPlannings?.replace(`${id}`, ""));
  };

  const handleChangeRelatedAccessoires = (e) => {
    if (cidAccessoires?.includes(e.target.value)) {
      if (relatedAccessoires?.length > 0)
        setRelatedAccessoires(`${relatedAccessoires},${e.target.value}`);
      else setRelatedAccessoires(e.target.value);
    }
    setRelatedAccessoiresInputValue(e.target.value);
  };
  const deleteRelatedAccessoires = (cid) => {
    if (relatedAccessoires?.includes(`${cid},`))
      setRelatedAccessoires(relatedAccessoires.replace(`${cid},`, ""));
    else if (relatedAccessoires?.includes(`${cid},`))
      setRelatedAccessoires(relatedAccessoires.replace(`,${cid}`, ""));
    else setRelatedAccessoires(relatedAccessoires?.replace(`${cid}`, ""));
  };

  const handleChangeRelatedRooms = (e) => {
    if (idRooms?.includes(e.target.value)) {
      if (relatedRooms?.length > 0)
        setRelatedRooms(`${relatedRooms},${e.target.value}`);
      else setRelatedRooms(e.target.value);
    }
    setRelatedRoomsInputValue(e.target.value);
  };
  const deleteRelatedRooms = (id) => {
    if (relatedRooms?.includes(`${id},`))
      setRelatedRooms(relatedRooms?.replace(`${id},`, ""));
    else if (relatedRooms?.includes(`${id},`))
      setRelatedRooms(relatedRooms?.replace(`,${id}`, ""));
    else setRelatedRooms(relatedRooms?.replace(`${id}`, ""));
  };

  // 🥉 PACK DUO + ANNIVERSAIRE + SNAKING INTERFACES -------------------------------------------------------------------
  const snakingInterface = () => {
    return (
      <div>
        <div className="form__inputbox" style={{ width: "410px" }}>
          <label htmlFor="relatedRooms" className="form__label">
            Lieu
          </label>
          <input
            value={relatedRoomsInputValue}
            onFocus={() => setRelatedRoomsInputValue("")}
            onChange={handleChangeRelatedRooms}
            type="email"
            name="relatedRooms"
            ref={register()}
            list="relatedRooms"
            className="form__input"
            style={{ padding: "0 8px 0 14px" }}
          />
          <datalist id="relatedRooms">
            {rooms
              .filter(({ id }) => !relatedRooms?.includes(id))
              .map(({ id, name }) => (
                <option className="form__dropdown" key={id} value={id}>
                  {name}
                </option>
              ))}
          </datalist>
        </div>
        {rooms?.map(({ id, name }) =>
          relatedRooms?.split(",")?.map((item, index) => {
            if (id.toString() === item)
              return (
                <div key={item} className="form__planningItem">
                  <div
                    className="form__planningText"
                    style={{ width: "10px", marginLeft: "12.6px" }}
                  >
                    {index + 1}
                  </div>
                  <PictureItem
                    image={`${process.env.REACT_APP_SITE_MARCHAND}/img/default_image.png`}
                    style={{
                      width: "3rem",
                      height: "3rem",
                      borderRadius: "3px",
                    }}
                  >
                    &nbsp;
                  </PictureItem>
                  <div className="form__planningText">{name}</div>
                  <Icons
                    onClick={() => deleteRelatedRooms(id)}
                    color="#ED292D"
                    style={{
                      width: "2rem",
                      height: "2rem",
                      marginLeft: "auto",
                    }}
                  >
                    <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                  </Icons>
                </div>
              );
          })
        )}
      </div>
    );
  };

  const handleChange = (e) =>
    setArticlesFill(
      articles.filter(({ name }) =>
        name.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase())
      )
    );

  return (
    <div className="gestion">
      <div className="gestion__header">
        <h4 className="gestion__title">Update formule</h4>
      </div>
      <div className="gestion__wrapper">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="form"
          noValidate="novalidate"
        >
          {/* :TODO: INFO */}
          <div className="form__container">
            <div className="form__inputboxWrapper">
              <Title color={"#183a68"}>Fiche formule :</Title>
              <div
                className="form__inputboxWrapper"
                style={{ width: "100%", justifyContent: "space-between" }}
              >
                <div className="form__inputbox">
                  <label htmlFor="name" className="form__label">
                    Nom
                  </label>
                  <input
                    name="name"
                    defaultValue={formule?.name}
                    onChange={(e) => setName(e.target.value)}
                    ref={register({ required: "Required" })}
                    className="form__input"
                  />
                  {errors.name && errors.name.message}
                </div>

                <div className="form__inputbox">
                  <label htmlFor="birthday" className="form__label">
                    Offre
                  </label>
                  <select
                    name="oid"
                    ref={register({ required: "Required" })}
                    className="form__input"
                    style={{ padding: "0 1rem" }}
                  >
                    {offres
                      .filter(({ aid }) => aid === aaid)
                      .map(({ oid, name }) => (
                        <option
                          className="form__dropdown"
                          selected={oid === formule?.oid ? "selected" : ""}
                          key={oid}
                          value={oid}
                        >
                          {name}
                        </option>
                      ))}
                  </select>
                  {errors.aid && errors.aid.message}
                </div>

                <div className="form__inputbox">
                  <label htmlFor="birthday" className="form__label">
                    Activité
                  </label>
                  <select
                    name="aid"
                    defaultValue={formule?.aid}
                    onChange={(e) => setAaid(e.target.value)}
                    ref={register({ required: "Required" })}
                    className="form__input"
                    style={{ padding: "0 1rem" }}
                  >
                    {activites.map(({ aid, name }) => (
                      <option
                        className="form__dropdown"
                        selected={aid === formule?.aid ? "selected" : ""}
                        key={aid}
                        value={aid}
                      >
                        {name}
                      </option>
                    ))}
                  </select>
                  {errors.aid && errors.aid.message}
                </div>

                <div className="form__inputbox">
                  <label htmlFor="birthday" className="form__label">
                    Classement
                  </label>
                  <input
                    name="classement"
                    defaultValue={formule?.classement}
                    type="number"
                    ref={register({ required: "Required" })}
                    className="form__input"
                  />
                  {errors.aid && errors.classement.message}
                </div>

                {aaid === ACTIVITES_ID[`evenements`] && (
                  <div className="form__inputbox">
                    <label htmlFor="classement" className="form__label">
                      Date
                    </label>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={activeDate}
                        onChange={() => setActiveDate(!activeDate)}
                        className="form__label"
                        style={{ cursor: "pointer", marginRight: ".7rem" }}
                      />
                      <DatePicker
                        onChange={onChange}
                        value={value}
                        format="d/M/yyyy"
                        minDate={new Date()}
                        disabled={!activeDate}
                        className="form__label"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                )}

                <div className="form__inputbox"></div>

                {/* SNAKING INPUT */}
                {aaid === ACTIVITES_ID[`snaking`] && snakingInterface()}

                {/* PACK DUO INPUT */}
                {(aaid === ACTIVITES_ID[`pack duo`] ||
                  aaid === ACTIVITES_ID[`evenements`]) && (
                    <div style={{ marginTop: "53px", width: "100%" }}>
                      {aaid === ACTIVITES_ID[`pack duo`] && (
                        <div style={{ marginBottom: "20px" }}>
                          <div
                            className="form__inputbox"
                            style={{ width: "410px" }}
                          >
                            <label htmlFor="relatedPack" className="form__label">
                              Plannings liés
                            </label>
                            <input
                              value={relatedPackInputValue}
                              onFocus={() => setRelatedPackInputValue("")}
                              onChange={handleChangeRelatedPack}
                              type="email"
                              name="relatedPack"
                              ref={register()}
                              list="relatedPack"
                              className="form__input"
                              style={{ padding: "0 8px 0 14px" }}
                            />
                            <datalist id="relatedPack">
                              {articles
                                .filter(({ id }) => !relatedPack?.includes(id))
                                .map(({ id, name }) => (
                                  <option
                                    className="form__dropdown"
                                    key={id}
                                    value={id}
                                  >
                                    {name}
                                  </option>
                                ))}
                            </datalist>
                          </div>
                          {relatedPack?.split(",")?.map((item, index) =>
                            articles?.map(({ id, name }) => {
                              if (item == id)
                                return (
                                  <div key={item} className="form__planningItem">
                                    <div
                                      className="form__planningText"
                                      style={{
                                        width: "10px",
                                        marginLeft: "12.6px",
                                      }}
                                    >
                                      {index + 1}
                                    </div>
                                    <Icons
                                      color="#FF5C00"
                                      style={{ width: "3rem", height: "3rem" }}
                                    >
                                      <use xlinkHref="/img/sprite.svg#icon-calendar"></use>
                                    </Icons>
                                    <div className="form__planningText">
                                      {name}
                                    </div>
                                    <Icons
                                      onClick={() => deleteRelatedPack(id)}
                                      color="#ED292D"
                                      style={{
                                        width: "2rem",
                                        height: "2rem",
                                        marginLeft: "auto",
                                      }}
                                    >
                                      <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                    </Icons>
                                  </div>
                                );
                            })
                          )}
                        </div>
                      )}
                      <div>
                        <div
                          className="form__inputbox"
                          style={{ width: "410px" }}
                        >
                          <label
                            htmlFor="relatedAccessoires"
                            className="form__label"
                          >
                            Equipements
                          </label>
                          <input
                            value={relatedAccessoiresInputValue}
                            onFocus={() => setRelatedAccessoiresInputValue("")}
                            onChange={handleChangeRelatedAccessoires}
                            type="email"
                            name="relatedAccessoires"
                            ref={register()}
                            list="relatedAccessoires"
                            className="form__input"
                            style={{ padding: "0 8px 0 14px" }}
                          />
                          <datalist id="relatedAccessoires">
                            {accessoires
                              .filter(
                                ({ cid }) => !relatedAccessoires?.includes(cid)
                              )
                              .map(({ cid, name }) => (
                                <option
                                  className="form__dropdown"
                                  key={cid}
                                  value={cid}
                                >
                                  {name}
                                </option>
                              ))}
                          </datalist>
                        </div>
                        {relatedAccessoires?.split(",")?.map((item, index) =>
                          accessoires?.map(({ cid, name, image }) => {
                            if (cid == item)
                              return (
                                <div key={item} className="form__planningItem">
                                  <div
                                    className="form__planningText"
                                    style={{
                                      width: "10px",
                                      marginLeft: "12.6px",
                                    }}
                                  >
                                    {index + 1}
                                  </div>
                                  <PictureItem
                                    image={`${process.env.REACT_APP_SITE_MARCHAND}${image}`}
                                    style={{
                                      width: "3rem",
                                      height: "3rem",
                                      borderRadius: "3px",
                                    }}
                                  >
                                    &nbsp;
                                  </PictureItem>
                                  <div className="form__planningText">{name}</div>
                                  <Icons
                                    onClick={() => deleteRelatedAccessoires(cid)}
                                    color="#ED292D"
                                    style={{
                                      width: "2rem",
                                      height: "2rem",
                                      marginLeft: "auto",
                                    }}
                                  >
                                    <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                  </Icons>
                                </div>
                              );
                          })
                        )}
                      </div>
                    </div>
                  )}

                {/* ANNIVERSAIRE INPUT */}
                {aaid === ACTIVITES_ID[`anniversaire`] && (
                  <>
                    <div className="anniversaire__inputWrapper">
                      <div className="form__inputbox anniversaire__offreInput">
                        <label
                          htmlFor="linked_formule1"
                          className="form__label"
                        >
                          Article 1
                        </label>
                        <input
                          name="linked_formule1"
                          defaultValue={subformules[0]?.linked_formule}
                          ref={register()}
                          type="text"
                          list="articles"
                          className="form__input"
                          style={{ padding: "0 8px 0 14px" }}
                        />
                        <datalist id="articles">
                          {articles.map(({ id, name }) => (
                            <option
                              className="form__dropdown"
                              key={id}
                              value={id}
                            >
                              {name}
                            </option>
                          ))}
                        </datalist>
                      </div>
                      <div className="form__inputbox anniversaire__timeInput">
                        <label htmlFor="start1" className="form__label">
                          délais (m)
                        </label>
                        <input
                          name="start1"
                          type="number"
                          min="0"
                          defaultValue={subformules[0]?.start}
                          ref={register()}
                          className="form__input"
                          style={{ padding: "0 4px 0 10px" }}
                        />
                      </div>
                    </div>
                    <div className="anniversaire__inputWrapper">
                      <div className="form__inputbox anniversaire__offreInput">
                        <label
                          htmlFor="linked_formule2"
                          className="form__label"
                        >
                          Article 2
                        </label>
                        <input
                          name="linked_formule2"
                          defaultValue={subformules[1]?.linked_formule}
                          ref={register()}
                          type="text"
                          list="articles"
                          className="form__input"
                          style={{ padding: "0 8px 0 14px" }}
                        />
                        <datalist id="articles">
                          {articles.map(({ id, name }) => (
                            <option
                              className="form__dropdown"
                              key={id}
                              value={id}
                            >
                              {name}
                            </option>
                          ))}
                        </datalist>
                      </div>
                      <div className="form__inputbox anniversaire__timeInput">
                        <label htmlFor="start2" className="form__label">
                          délais (m)
                        </label>
                        <input
                          name="start2"
                          type="number"
                          min="0"
                          defaultValue={subformules[1]?.start}
                          ref={register()}
                          className="form__input"
                          style={{ padding: "0 4px 0 10px" }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div style={{ width: "25%", height: "100%" }}>
              <Title color={"#183a68"}>Formule démo :</Title>
              <div className="card">
                <Heading
                  color={color.hex}
                  style={
                    aaid === ACTIVITES_ID[`pack duo`] ? { height: "13%" } : {}
                  }
                >
                  {name}
                </Heading>
                <Picture
                  image={imageURL ? imageURL : "/img/default_image.png"}
                  style={
                    aaid === ACTIVITES_ID[`pack duo`] ? { height: "91%" } : {}
                  }
                >
                  &nbsp;
                </Picture>
              </div>
            </div>
          </div>

          {/* :FIXME: IMAGE & COLOR */}
          <div
            className="form__container"
            style={{
              marginTop: aaid === ACTIVITES_ID[`anniversaire`] ? "0px" : "53px",
            }}
          >
            {/*🐫👽👼 */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label htmlFor="birthday" className="form__label">
                Article V12
              </label>
              <input
                name="search"
                onChange={handleChange}
                placeholder="Rechercher"
                className="form__input  list__input"
              />
              <div className="list__wrapper">
                <ItemsList
                  articles={articlesFill}
                  selectedArticle={selectedArticle}
                  setSelectedArticle={setSelectedArticle}
                />
              </div>
            </div>

            <div className="gestion__imageWrapper">
              <label htmlFor="image" className="form__label">
                Importer une image
              </label>
              <div {...getRootProps()} className="dropzone">
                <input {...getInputProps()} />
                <img
                  src="/img/icon/upload.svg"
                  alt="upload"
                  style={{ width: "120px" }}
                />
              </div>
            </div>

            <div className="gestion__colorWrapper">
              <label htmlFor="color" className="form__label">
                Choisir un color
              </label>
              <div style={{ marginTop: "1rem" }}>
                <ChromePicker
                  color={color}
                  onChange={(color) => setColor(color)}
                />
              </div>
            </div>
          </div>

          <div className="text__container">
            <div className="text__inputContainer">
              <div className="borne__label" style={{ marginBottom: "1rem" }}>
                TEXTE
              </div>
              <div className="">
                <textarea
                  name="topText"
                  ref={register({})}
                  className="text__input"
                  defaultValue={strings["string_1"]?.replace(
                    /<br\s*\/?>/gi,
                    "\n"
                  )}
                  onChange={(e) =>
                    setStrings({
                      string_1: e.target.value,
                      string_2: strings["string_2"],
                    })
                  }
                  style={{
                    width: "100%",
                    fontSize: "1.6rem",
                    marginBottom: "1rem",
                  }}
                  rows="4" // Adjust the rows to set the height of the textarea
                  placeholder="Entrez votre texte du haut ici..."
                />
                <textarea
                  name="bottomText"
                  ref={register({})}
                  className="text__input"
                  defaultValue={strings["string_2"]?.replace(
                    /<br\s*\/?>/gi,
                    "\n"
                  )}
                  onChange={(e) =>
                    setStrings({
                      string_1: strings["string_1"],
                      string_2: e.target.value,
                    })
                  }
                  style={{ width: "100%", fontSize: "1.6rem" }}
                  rows="4"
                  placeholder="Entrez votre texte du bas ici..."
                />
              </div>
            </div>
          </div>

          {true && (
            <div className="borne">
              <div className="borne__switchContainer">
                <div className="borne__switch">
                  <div className="borne__label">site marchand</div>
                  <Switch
                    checked={web}
                    onColor={color.hex}
                    onChange={() => setWeb(!web)}
                  />
                </div>
                <div className="borne__switch">
                  <div className="borne__label">borne</div>
                  <Switch
                    checked={borne}
                    onColor={color.hex}
                    onChange={() => setBorne(!borne)}
                  />
                </div>
              </div>

              {/* :TODO: */}
              <div className="" style={{ marginTop: "20px" }}>
                <div className="gestion__imageWrapper">
                  <label htmlFor="image" className="form__label">
                    Borne
                  </label>
                  <div className="">
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      style={{ display: "none" }}
                    />
                    <img
                      onClick={handleUploadClick}
                      src="/img/icon/upload.svg"
                      alt="upload"
                      style={{ width: "40px", cursor: "pointer" }}
                    />
                  </div>
                </div>
                <img
                  src={imageBorne}
                  alt=""
                  style={{ width: "100%", marginTop: "10px" }}
                  onError={(e) => {
                    e.target.onerror = null; // Prevents looping
                    e.target.src = `${process.env.REACT_APP_SITE_MARCHAND}/img/default_image_borne.png`; // Path to your default image
                  }}
                />
              </div>

              {!!borne && (
                <>
                  {/* :FIXME: */}
                  <div className="" style={{ marginTop: "20px" }}>
                    <div className="gestion__imageWrapper">
                      <label htmlFor="image" className="form__label">
                        recommendations
                      </label>
                      <div className="borne__switch" style={{ width: "250px" }}>
                        <div className="borne__label">recommendations</div>
                        <Switch
                          checked={promotion}
                          onColor={color.hex}
                          onChange={() => setPromotion(!promotion)}
                        />
                      </div>
                      <div className="">
                        <input
                          ref={fileInputAdsRef}
                          type="file"
                          accept="image/*"
                          onChange={handleImageAdsChange}
                          style={{ display: "none" }}
                        />
                        <img
                          onClick={handleUploadAdsClick}
                          src="/img/icon/upload.svg"
                          alt="upload"
                          style={{ width: "40px", cursor: "pointer" }}
                        />
                      </div>
                    </div>
                    <img
                      src={imageAds}
                      alt=""
                      style={{ width: "350px", marginTop: "10px" }}
                    />
                  </div>

                  <div style={{ marginTop: "53px", width: "100%" }}>
                    <div>
                      <div className="" style={{ display: "flex" }}>
                        <div className="" style={{ marginRight: "20px" }}>
                          <div
                            className="borne__label"
                            style={{ marginBottom: "18px" }}
                          >
                            couleur primaire
                          </div>
                          <TwitterPicker
                            color={primaryColor}
                            onChange={({ hex }) => setPrimaryColor(hex)}
                            colors={[primaryColor]}
                          />
                        </div>
                        <div className="" style={{ marginRight: "20px" }}>
                          <div
                            className="borne__label"
                            style={{ marginBottom: "18px" }}
                          >
                            couleur secondaire
                          </div>
                          <TwitterPicker
                            color={secondaryColor}
                            onChange={({ hex }) => setSecondaryColor(hex)}
                            colors={[secondaryColor]}
                          />
                        </div>
                        <div className="">
                          <div
                            className="borne__label"
                            style={{ marginBottom: "18px" }}
                          >
                            couleur de fond
                          </div>
                          <TwitterPicker
                            color={backgroundColor}
                            onChange={({ hex }) => setBackgroundColor(hex)}
                            colors={[backgroundColor]}
                          />
                        </div>
                      </div>

                      <div
                        className="form__inputbox"
                        style={{ width: "410px", marginTop: "50px" }}
                      >
                        <label
                          htmlFor="relatedPackBorne"
                          className="form__label"
                        >
                          Plannings liés
                        </label>
                        <input
                          value={relatedPlanningsInputValue}
                          onFocus={() => setRelatedPlanningsInputValue("")}
                          onChange={handleChangeRelatedPlannings}
                          type="text"
                          name="relatedPlannings"
                          ref={register()}
                          list="relatedPlannings"
                          className="form__input"
                          style={{ padding: "0 8px 0 14px" }}
                        />
                        <datalist id="relatedPlannings">
                          {taches
                            .filter(({ id }) => !relatedPlannings?.includes(id))
                            .map(({ id, label }) => (
                              <option
                                className="form__dropdown"
                                key={id}
                                value={id}
                              >
                                {label}
                              </option>
                            ))}
                        </datalist>
                      </div>

                      {relatedPlannings?.split(",")?.map((item, index) =>
                        taches?.map(({ id, label }) => {
                          if (item == id)
                            return (
                              <div key={item} className="form__planningItem">
                                <div
                                  className="form__planningText"
                                  style={{
                                    width: "10px",
                                    marginLeft: "12.6px",
                                  }}
                                >
                                  {index + 1}
                                </div>
                                <Icons
                                  color="#FF5C00"
                                  style={{ width: "3rem", height: "3rem" }}
                                >
                                  <use xlinkHref="/img/sprite.svg#icon-calendar"></use>
                                </Icons>
                                <div className="form__planningText">
                                  {label}
                                </div>
                                <Icons
                                  onClick={() => deleteRelatedPlannings(id)}
                                  color="#ED292D"
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                    marginLeft: "auto",
                                  }}
                                >
                                  <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                </Icons>
                              </div>
                            );
                        })
                      )}
                    </div>

                    {/* <div style={{ marginTop: '20px' }}>
                                <div className="form__inputbox" style={{ width: '410px' }}>
                                    <label htmlFor="relatedAccessoires" className="form__label">
                                        Equipements
                                    </label>
                                    <input value={relatedAccessoiresInputValue} onFocus={() => setRelatedAccessoiresInputValue('')} onChange={handleChangeRelatedAccessoires} type="text" name="relatedAccessoires" ref={register()} list="relatedAccessoires" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                                    <datalist id="relatedAccessoires">
                                        {accessoires
                                            .filter(({ cid }) => !relatedAccessoires?.includes(cid))
                                            .map(({ cid, name }) => (
                                                <option className="form__dropdown" key={cid} value={cid}>
                                                    {name}
                                                </option>
                                            ))}
                                    </datalist>
                                </div>
                                {relatedAccessoires?.split(',')?.map((item, index) =>
                                    accessoires?.map(({ cid, name, image }) => {
                                        if (cid == item)
                                            return (
                                                <div key={item} className="form__planningItem">
                                                    <div className="form__planningText" style={{ width: '10px', marginLeft: '12.6px' }}>
                                                        {index + 1}
                                                    </div>
                                                    <PictureItem image={`${process.env.REACT_APP_SITE_MARCHAND}${image}`} style={{ width: '3rem', height: '3rem', borderRadius: '3px' }}>
                                                        &nbsp;
                                                    </PictureItem>
                                                    <div className="form__planningText">{name}</div>
                                                    <Icons onClick={() => deleteRelatedAccessoires(cid)} color="#ED292D" style={{ width: '2rem', height: '2rem', marginLeft: 'auto' }}>
                                                        <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                                    </Icons>
                                                </div>
                                            );
                                    })
                                )}
                            </div> */}
                  </div>

                  <div style={{ display: "flex", marginTop: "40px" }}>
                    <div
                      className="form__inputbox"
                      style={{ marginRight: "30px" }}
                    >
                      <label htmlFor="birthday" className="form__label">
                        participants minimum
                      </label>
                      <input
                        name="placesMin"
                        defaultValue={formule?.placesMin}
                        type="number"
                        min="1"
                        max={watch("placesMax")}
                        ref={register({ required: "Required" })}
                        className="form__input"
                      />
                      {errors.aid && errors.placesMin.message}
                    </div>
                    <div className="form__inputbox">
                      <label htmlFor="birthday" className="form__label">
                        participants maximum
                      </label>
                      <input
                        name="placesMax"
                        defaultValue={formule?.placesMax}
                        type="number"
                        min={watch("placesMin")}
                        ref={register({ required: "Required" })}
                        className="form__input"
                      />
                      {errors.aid && errors.placesMax.message}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          <div className="gestion__buttonWrapper" style={{ marginTop: "20px" }}>
            <button
              className="facture__button"
              style={{
                fontSize: "1.5rem",
                width: "15rem",
                backgroundColor: "#0D53FC",
              }}
            >
              Update
            </button>
            <Link to="/formules">
              <button
                className="facture__button"
                style={{
                  fontSize: "1.5rem",
                  width: "15rem",
                  backgroundColor: "#fc114c",
                }}
              >
                Fermer
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateFormule;
